import React, { useEffect } from "react";

import { useForm, useWatch } from "react-hook-form-7";
import useTranslations from "../../hooks/useTranslations";
import { Input, Textarea, RadioGroup, Radio } from "../wombat-ui";

import { VStack } from '@chakra-ui/react';

export type CampaignInput = {
  id: string;
  name: string;
  description: string;
  reminderGap: number;
  reminderEnabled: "true" | "false";
  companyId: string;
};

type CampaignFormProps = {
  formId: string;
  onSubmit: (input: CampaignInput) => void;
  defaultValues?: Partial<CampaignInput>;
};

const CampaignForm: React.FC<CampaignFormProps> = ({
  formId,
  onSubmit,
  defaultValues = {
    userIds: [],
  },
}) => {
  const t = useTranslations();

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
  } = useForm<CampaignInput>({
    defaultValues: {
      name: "",
      description: "",
      reminderGap: defaultValues?.reminderGap,
      reminderEnabled: defaultValues?.reminderEnabled,
      ...defaultValues,
    },
  });

  useEffect(() => {
    register("reminderGap");
  }, [defaultValues]);

  const reminderSelector = useWatch({
    control: control,
    name: `reminderEnabled`,
  });

  return (
    <form id={formId} onSubmit={handleSubmit(onSubmit)}>
      <VStack
        spacing={8}
        align="stretch"
      >
        <Input
          id="campaign-name"
          label={t("forms.fields.name") as string}
          error={errors?.name}
          {...register("name", {
            required: t("forms.errors.required") as string,
          })}
        />
        <Textarea
          id="campaign-description"
          label={t("forms.fields.description") as string}
          rows={3}
          error={errors?.description}
          {...register("description")}
        />
        <RadioGroup
          title={t("company.reminderEnabledLabel")}
          description={t("company.reminderEnabledDescription")}
        >
          <Radio
            id={`reminder-true`}
            label={t("forms.actions.yes") as string}
            value={"true"}
            {...register("reminderEnabled")}
          />
          <Radio
            id={`reminder-false`}
            label={t("forms.actions.no") as string}
            value={"false"}
            {...register("reminderEnabled")}
          />
        </RadioGroup>
        {reminderSelector === "true" && (
          <Input
            label={t("company.reminderGapLabel") as string}
            type="number"
            min={1}
            id="reminderGap"
            {...register("reminderGap", { valueAsNumber: true })}
            defaultValue={defaultValues?.reminderGap}
          />
        )}
      </VStack>
    </form>
  );
};

export default CampaignForm;
